<template>
  <v-container>
    <v-layout row wrap v-if="Object.keys(location).length > 0">
      <v-flex xs12 class="pl-3 pr-3 pb-3">
        <v-card>
          <v-card-title class="mb-1"><b>{{ location.name }}</b></v-card-title>
          <v-divider></v-divider>          
          <v-card-text>
            <p class="add-event-review-header">Address</p>
            <p class="event-page-sub-heading-small mb-3">{{convertLocationType(location.location_type)}}{{locationShort}}</p>
            <p class="event-page-sub-heading">About the location</p>
            <p class="event-page-content" v-html="newlines(location.description)"></p>
            <google-map 
              class="mt-5"
              :mapcenter='mapcenter'
              :zoom='mapzoom'
              :radius="350">
            </google-map>
          </v-card-text>
          <v-card-actions>
            <v-btn color="warning" @click="openEditModal">Request Change</v-btn>
          </v-card-actions>
        </v-card>
      </v-flex>
      <v-flex xs12 class="pa-3">
        <v-card>
          <v-card-title class="text-xs-center mb-1"><b>Photos</b></v-card-title>
          <v-divider></v-divider>
          <v-card-text>
            <v-layout row wrap>
              <v-flex xs6 md4 class="pa-3">
                <v-badge
                  color="purple"
                  left
                  overlap
                >
                  Primary image
                </v-badge>
                <v-card>
                  <v-img
                    :src="location.primary_image.image"
                    aspect-ratio="1.7778"
                  ></v-img>
                  <v-card-title>{{ location.primary_image.filename }}<br>Primary Photo</v-card-title>
                </v-card>
              </v-flex>
              <v-flex xs6 md4 class="pa-3" v-for="photo in location.additional_images" :key="photo.filename">
                <v-card>
                  <v-img
                    :src="photo.image"
                    aspect-ratio="1.7778"
                  ></v-img>
                  <v-card-title>{{ photo.filename }}</v-card-title>
                  <v-card-actions>
                    <!-- <v-btn>Make primary</v-btn> -->
                  </v-card-actions>
                </v-card>
              </v-flex>
            </v-layout>
          </v-card-text>
          <v-card-actions>
            <v-btn color="warning" @click="openEditModal">Request Photo Change</v-btn>
          </v-card-actions>
        </v-card>
      </v-flex>
      <v-flex xs12 class="pa-3">
        <v-card>
          <v-card-text>
            <div class="mb-1 pb-1" v-if="getLocationEvents.length > 0">
              <p class="mb-3" style="font-size: 1.1em; color: #666; font-weight: bold;">
                Upcoming events at this location
              </p>
              <v-layout row wrap>
                <v-flex xs12 md4 v-for="event in getLocationEvents" :key="event.pk" class="pa-3 mb-4">
                  <event-list-item :event="event"></event-list-item>
                </v-flex>
              </v-layout>
            </div>
            <div class="mb-1 pb-1 mt-5" v-else>
              <p class="mb-3" style="font-size: 1.1em; color: #666; font-weight: bold;">
                Hmm... Looks like no WRKPRTYs are scheduled for this location at this time. Check out these other upcoming events nearby!
              </p>
              <p>
                <v-layout row wrap>
                  <v-flex xs12 md4 v-for="event in getAllEvents.slice(0,3)" :key="event.pk" class="pa-1">
                    <event-list-item :event="event"></event-list-item>
                  </v-flex>
                </v-layout>
              </p>
            </div>
          </v-card-text>
        </v-card>
      </v-flex>
    </v-layout>
  </v-container>
</template>

<script>
import GoogleMap from '~/components/GoogleMap'
import EventListItem from '~/components/EventListItem.vue'

import { fetchAllEvents, fetchLocationBySlug } from '~/store/api/event_location_api'

import {mapActions, mapGetters} from 'vuex'
import { replaceNewlines } from '~/store/util/util'
import moment from 'moment'

export default {
  name: 'host_dashboard_location_details',
  data () {
    return {
      location: {},
      locationPk: null,
      mapzoom: 15
    }
  },
  beforeRouteEnter(to, from, next) {
    fetchLocationBySlug(to.params.slug).then((response) => {
      next(vm => {
        vm.setLocation(response.data)
      })
    }).catch((error) => {
      console.error(error)
      next()
    })
  },
  watch: {
		currentTab() {
			// Call resizePreserveCenter() on all maps
			Vue.$gmapDefaultResizeBus.$emit('resize')
		}
	},
  methods: {
    ...mapActions([
      'setEditEventContactFormEvent',
      'setModalOpen',
    ]),
    setLocation(data) {
      this.location=data
    },
    openEditModal () {
			this.setEditEventContactFormEvent(this.event)
			this.setModalOpen({ prop: 'editEventContactForm', value: true })
		},
    convertLocationType(val) {
			if (val === 'public') {
				return 'Public space - '
			} else if (val === 'house') {
				return 'Private home - '
			} else if (val === 'office') {
				return 'Office - '
			} else if (val === 'commercial') {
				return 'Commercial space - '
			} else {
				return ''
			}
    },
    newlines(value) {
			return replaceNewlines(value)
		},
  },
  computed: {
    ...mapGetters([
      'user',
      'getAllEvents',
      'getLocationDistance',
    ]),
    locationShort() {
			let locationString = ''
			if (this.location.hasOwnProperty('address')) {
				let addressComponents = []
				if (this.isHost) {
					if (this.location.address.hasOwnProperty('street_number')) {
						if (this.location.address.hasOwnProperty('route')) {
							addressComponents.push(
								this.location.address.street_number +
									' ' +
									this.location.address.route
							)
						}
					}
				} else {
					if (this.location.address.hasOwnProperty('neighborhood')) {
						if (this.location.address.neighborhood !== '') {
							addressComponents.push(this.location.address.neighborhood)
						}
					}
				}
				if (this.location.address.hasOwnProperty('city')) {
					addressComponents.push(this.location.address.city)
				}
				if (this.location.address.hasOwnProperty('state')) {
					addressComponents.push(this.location.address.state)
				}
				if (this.location.address.hasOwnProperty('country')) {
					if (this.location.address.country !== 'United States') {
						addressComponents.push(this.location.address.country)
					}
				}
				for (var i = 0; i < addressComponents.length; i++) {
					locationString += addressComponents[i]
					if (i < addressComponents.length - 1) {
						locationString += ', '
					}
				}
			}
			return locationString
    },
    getLocationEvents() {
			// let events = this.getAllEvents
			return this.getAllEvents.filter(e => {
				return e.location.pk === this.location.pk
			})
			// let locationEvents = []
			// for (var i = 0; i < events.length; i++) {
			// 	if (events[i].location.pk === this.location.pk) {
			// 		if (events[i].approved) {
			// 			locationEvents.push(events[i])
			// 		}
			// 	}
			// }
			// return locationEvents
		},
    getNearbyEvents() {
			let events = this.getAllEvents
			let nearbyEvents = []
			for (var i = 0; i < events.length; i++) {
				if (events[i].approved) {
					let distance = this.getLocationDistance(events[i].location.pk)
					nearbyEvents.push({ event: events[i], distance: distance })
				}
			}
			nearbyEvents.sort(function(a, b) {
				return a.distance - b.distance
			})
			let finalEvents = nearbyEvents.map(obj => {
				return obj.event
			})
			return finalEvents.slice(0, 2)
		},
    isHost() {
			if (this.location) {
				return this.user.pk === this.location.owner || this.location.coowners.findIndex((owner) => owner === this.user.pk)
			}
    },
    mapcenter() {
			return {
				lat: parseFloat(
					this.location.address.private_latitude ||
						this.location.address.public_latitude
				),
				lng: parseFloat(
					this.location.address.private_longitude ||
						this.location.address.public_longitude
				)
			}
		},
  },
  components: {
		GoogleMap,
		EventListItem,
	}
}
</script>

<style>

</style>
